/**
 *
 * This function is expected to round and return in float
 * @param  {*} num
 * @param  {*} digit=2
 * @return {*}
 */
export function round(num, digit = 2) {
  if (num) {
    return parseFloat(num.toFixed(digit));
  } else {
    return 0;
  }
}
/**
 *
 * This function is expected to round and return in float
 * @param  {*} num
 * @param  {*} digit=2
 * @return {*}
 */
export function roundToDigit(num, digit = 2) {
  return parseFloat(num.toFixed(digit));
}
/**
 *
 * @param {*} key
 * @return {*}
 */
export function getDetailsFromKey(key) {
  const keyDetails = key.split('|');
  return keyDetails[1];
}

/**
 *
 * @param {*} array
 * @param {*} key
 * @return {*}
 */
export function groupBy(array, key) {
  const groupByKey = {};
  if (array && key && array.length > 0) {
    array.map((currentValue) => {
      const value = currentValue[key];
      if (value in groupByKey) {
        groupByKey[value].push(currentValue);
      } else {
        groupByKey[value] = [currentValue];
      }
    });
  }
  return groupByKey;
}

/**
 *
 * @param {*} rowIndex
 * @param {*} type
 * @param {*} columnDetails
 * @return {*}
 */
export function convertCellWithForumlaForExcel(rowIndex, type, columnDetails) {
  let formula = null;
  const formatType = 'currency';
  const equivalentSharesCharStart = columnDetails['Equivalent Shares'];
  const grantFairValueCharStart = columnDetails['Grant Date Fair Value'];
  const equivalentSharesCharEnd = incrementColumnForExcel(grantFairValueCharStart, -1);
  const grantFairValueCharEnd = incrementColumnForExcel(columnDetails['Total Fair Value'], -1);

  switch (type) {
    case 'total_fair_value':
      // eslint-disable-next-line max-len
      formula = `SUMPRODUCT(${equivalentSharesCharStart}${rowIndex}:${equivalentSharesCharEnd}${rowIndex},${grantFairValueCharStart}${rowIndex}:${grantFairValueCharEnd}${rowIndex})`;
      break;
    case 'offering_period':
      formula = `G${rowIndex}-F${rowIndex}`;
      break;
    case 'expense_per_day':
      formula = `${columnDetails['Total Fair Value']}${rowIndex}/(${columnDetails['periodDays']}${rowIndex})`;
      break;
    case 'empty_difference':
      formula = `G${rowIndex}-G${rowIndex}`;
      break;
  }
  if (formula && formatType) {
    return Object.assign(convertCellForExcel(0, formatType), {
      f: formula,
    });
  } else if (formula) {
    return {
      f: formula,
    };
  }
  return convertCellForExcel(0, type);
}

/**
 *
 * @param {*} value
 * @param {*} type
 * @return {*}
 */
export function convertCellForExcel(value, type) {
  switch (type) {
    case 'currency':
      return {
        t: 'n',
        v: value,
        z: '_($* #,##0.00_);_($* (#,##0.00);_($* "-"??_);_(@_)',
      };
    case 'date':
      return {
        t: 'd',
        v: value,
        z: 'M/d/yyyy',
      };
    case 'number':
      return {
        z: '_(* #,##0_);_(* (#,##0);_(* -??_);_(@_)',
        v: value,
        t: 'n',
      };
  }
  return value;
}

/**
 *
 * @param {*} list
 * @param {*} length
 * @return {*}
 */
export function getRandomString(list, length) {
  let randomString = '';
  for (let x = 0; x < length; x++) {
    const i = Math.floor(Math.random() * list.length);
    randomString += list.charAt(i);
  }
  return randomString;
}

/**
 *
 * @return {*}
 */
export function generatePassword() {
  const specials = '!@#$%^&*()_+{}:"<>?\|[];\',./`~';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';

  return getRandomString(uppercase, 4) + getRandomString(lowercase, 6) +
    getRandomString(numbers, 4) + getRandomString(specials, 2);
}

/**
 *
 * @param {*} inputString
 * @return {*}
 */
export function checkForNumbers(inputString) {
  if (typeof inputString === 'number') {
    return true;
  }
  const numbers = '1234567890';
  let hasNumber = false;
  for (let i = 0; i < inputString.length; i++) {
    if (numbers.includes(inputString[i])) hasNumber = true;
  }
  return hasNumber;
}

/**
 *
 * @param {*} inputString
 * @return {*}
 */
export function checkForSymbols(inputString) {
  const specials = '!@#$%^&*()_+{}:"<>?|[];\',./`~';
  let hasSymbol = false;
  for (let i = 0; i < inputString.length; i++) {
    if (specials.includes(inputString[i])) hasSymbol = true;
  }
  return hasSymbol;
}

/**
 *
 * @param {*} inputString
 * @return {*}
 */
export function checkForUpperCase(inputString) {
  let hasUpperCase = false;
  const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < inputString.length; i++) {
    if (
      alpha.includes(inputString[i].toUpperCase()) &&
      inputString[i] === inputString[i].toUpperCase()
    ) {
      hasUpperCase = true;
    }
  }
  return hasUpperCase;
}

/**
 *
 * @param {*} inputString
 * @return {*}
 */
export function checkForLowerCase(inputString) {
  let hasLowerCase = false;
  const alpha = 'abcdefghijklmnopqrstuvwxyz';
  for (let i = 0; i < inputString.length; i++) {
    if (
      alpha.includes(inputString[i].toLowerCase()) &&
      inputString[i] === inputString[i].toLowerCase()
    ) {
      hasLowerCase = true;
    }
  }
  return hasLowerCase;
}
/**
 *
 * @param {*} value
 * @param {*} digits
 * @return {*}
 */
export function floorToDigits(value, digits = 2) {
  return Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits);
}

/**
 *
 * @param {*} records
 * @param {*} field
 * @return {*}
 */
export function removeDuplicates(records, field) {
  const uniqueRecords = [];
  for (const c of records) {
    const found = uniqueRecords.find((item) => item[field] === c[field]);
    if (!found) {
      uniqueRecords.push(c);
    }
  }
  return uniqueRecords;
}

/**
 *
 * @param {*} char
 * @return {*}
 */
export function getNextColumnForExcel(char) {
  let nextChar = '';

  // Get last character of char
  const lastChar = char[char.length - 1];
  if (lastChar !== 'Z') {
    nextChar = String.fromCharCode(char.charCodeAt(char.length - 1) + 1);
    if (char.length !== 1) {
      nextChar = char.substring(0, char.length - 1) + nextChar;
    }
  } else {
    nextChar = 'AA';
  }
  return nextChar;
}

/**
 *
 * @param {*} char
 * @param {*} by
 * @return {*}
 */
export function incrementColumnForExcel(char, by = 1) {
  return String.fromCharCode(char.charCodeAt(0) + by);
}
